import { baseSplitApi } from "../baseApi";

const clientPath = "/prospective_clients";
const newClient = "newClient"
const clientTypesPath = "/prospective_clients/client_types"
const updatedClient = "updatedClient"


export const addClientPathApi = baseSplitApi.injectEndpoints({
  endpoints: (build) => ({
    addClient: build.mutation({
      query: (body) => {
        return {
          url: clientPath,
          body: body,
          method: 'POST'
        }
      },
      invalidatesTags: [newClient]
    }),
    getClients: build.query({
      query: () => {
        return {
          url: clientPath,
          method: 'GET'
        }
      },
      providesTags: [newClient]
    }),
    getClientTypes: build.query({
      query: () => {
        return {
          url: clientTypesPath,
          method: 'GET'
        }
      },
    }),
    updateClient: build.mutation({
      query: (reqData) => {
        const { id, clientName, domainName, clientType, updatePageAccess, pageAccessRightsDbID, panelDashboardLink, marketingMaterial } = reqData
        return {
          url: `${clientPath}/${id}`,
          method: 'PUT',
          body: { domainName, clientName, clientType, updatePageAccess, pageAccessRightsDbID, panelDashboardLink, marketingMaterial }
        }
      }, invalidatesTags: [newClient, updatedClient]
    }),
    getClient: build.query({
      query: (id) => {
        return {
          url: `${clientPath}/${id}`
        }
      },
      providesTags: [newClient, updatedClient]
    }),
    deleteClient: build.mutation({
      query: (id) => {
        return {
          url: `${clientPath}/${id}`,
          method: 'DELETE'
        }
      },
      invalidatesTag: [newClient]
    }),
  })
})
export const { useAddClientMutation, useGetClientsQuery, useGetClientQuery, useGetClientTypesQuery, useDeleteClientMutation, useUpdateClientMutation } = addClientPathApi